import React from 'react'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'
import cn from 'classnames'
import ImmutablePropTypes from 'react-immutable-proptypes'

import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'

import './styles.scss'
const bc = 'select-component'

const Select = ({
  id,
  showLabel,
  options,
  disabled,
  label,
  input,
  meta: { touched, error },
  size,
  isRowView,
  className,
  classNameSelect,
  classNameSelectWrapper,
  labelClassName,
  getLabel,
  getValue,
  getKey,
  styleSelect,
}) => {
  const selectId = id || uniqueId(bc)

  return (
    <div className={cn(bc, { [`${bc}__row`]: isRowView }, className)}>
      {showLabel && (
        <div className={cn(`${bc}__label-wrapper`, { [`${bc}__label-row`]: isRowView }, labelClassName)}>
          <label htmlFor={selectId} className={`${bc}__label`}>
            {label}
          </label>
        </div>
      )}
      <div className={cn(`${bc}__select-wrapper`, classNameSelectWrapper)}>
        <select
          {...input}
          id={selectId}
          disabled={disabled}
          size={size}
          className={cn(`${bc}__select`, { error: touched && error }, classNameSelect)}
          style={{ ...styleSelect }}
        >
          {options.map(option => (
            <option key={getKey(option)} value={getValue(option)}>
              {getLabel(option)}
            </option>
          ))}
        </select>
        {touched && error && <ErrorLabel before={label} htmlFor={selectId} error={error} />}
      </div>
    </div>
  )
}

Select.defaultProps = {
  isRowView: true,
  showLabel: true,
  disabled: false,
  options: [],
  input: {},
  meta: {},
  getLabel: option => (option && option.label ? option.label : option),
  getValue: option => (option && option.value ? option.value : option),
  getKey: option => (option && option.key ? option.key : uniqueId()),
  styleSelect: {},
}

Select.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showLabel: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.array, ImmutablePropTypes.list, ImmutablePropTypes.set]).isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  size: PropTypes.number,
  isRowView: PropTypes.bool,
  className: PropTypes.string,
  classNameSelect: PropTypes.string,
  classNameSelectWrapper: PropTypes.string,
  getLabel: PropTypes.func,
  getValue: PropTypes.func,
  getKey: PropTypes.func,
  styleSelect: PropTypes.object,
}

export default Select
